import Vue from 'vue';
export default {

    RESET_STATE(state, data) {
        return data;
    },

    UPDATE_FACETS(state, facets) {
        state.facets = { ...state.facets, ...facets };
    },

    UPDATE_PAGED(state, paged) {
        state.paged = { ...state.paged, ...paged };
    },

    UPDATE_FILTER(state, filter) {
        state.filter = { ...state.filter, ...filter };
    },

    REMOVE_FILTER(state, taxonomy) {
        Vue.set(state.filter, taxonomy.slug, []);
    },

    ADD_FILTER_DURATION(state, durationToAdd) {
        const durationsFilter = state.filter.durations.filter(
            duration => duration !== durationToAdd
        );
        durationsFilter.push(durationToAdd);

        state.filter.durations = durationsFilter;
    },

    REMOVE_FILTER_DURATION(state, durationToRemove) {
        const durationsFilter = state.filter.durations.filter(
            duration => duration !== durationToRemove
        );

        state.filter.durations = durationsFilter;
    },

    ADD_FILTER_TERM(state, payload) {
        const terms = (state.filter[payload.taxonomy.slug] || [])
            .filter(term => term !== payload.term.slug);
        terms.push(payload.term.slug);
        Vue.set(state.filter, payload.taxonomy.slug, terms);
    },

    REMOVE_FILTER_TERM(state, payload) {
        const terms = (state.filter[payload.taxonomy.slug] || [])
            .filter(term => term !== payload.term.slug);
        Vue.set(state.filter, payload.taxonomy.slug, terms);
    },

    UPDATE_SORT(state, sort) {
        state.sort = { ...state.sort, ...sort };
    },

    UPDATE_OPTIONS(state, options) {
        state.options = { ...state.options, ...options };
    },

    UPDATE_RENDER_TYPE(state, renderType) {
        state.render_type = renderType;
    },

    UPDATE_HTML(state, html) {
        state.html = html;
    },

    SET_PAGE_NUM(state, page_num) {
        state.paged.page_num = page_num;
    },

    SET_PAGE_SIZE(state, page_size) {
        state.paged.page_size = page_size;
    },

    SET_BUSY_STATE(state, busy) {
        Vue.set(state, 'busy', busy);
    }
};
